/**
 * Funzioni di formattazione per il modulo flyers
 * @module flyers/utils/formatters
 */

import dayjs from "dayjs";

/**
 * Converte un valore data in oggetto dayjs
 * @param {any} value - Valore data (stringa o altro)
 * @returns {dayjs.Dayjs|null} Oggetto dayjs o null se invalido
 */
export const parseDateValue = (value) => {
    if (!value) return null;
    const direct = dayjs(String(value));
    if (direct.isValid()) return direct;
    const fallback = dayjs(String(value).replace(/\//g, "-"));
    return fallback.isValid() ? fallback : null;
};

/**
 * Converte un nome di campo in una chiave normalizzata
 * @param {any} name - Nome del campo
 * @returns {string} Chiave normalizzata (lowercase, senza accenti, underscore al posto di spazi)
 */
export const toFieldKey = (name) => {
    if (!name) return "";
    return String(name)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
};

/**
 * Sanitizza un nome file rimuovendo caratteri speciali
 * @param {any} value - Nome file da sanitizzare
 * @returns {string} Nome file sanitizzato
 */
export const sanitizeFileName = (value) => {
    if (!value) return "";
    return String(value)
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9-_]+/g, "-")
        .replace(/^-+|-+$/g, "");
};

/**
 * Rinomina un file aggiungendo una label sanitizzata come nome
 * @param {File} file - File originale
 * @param {string} label - Label da usare come nuovo nome
 * @returns {File} Nuovo file con nome aggiornato
 */
export const renameFileWithLabel = (file, label) => {
    const safeLabel = sanitizeFileName(label);
    if (!safeLabel) return file;
    const extension = file.name.includes(".")
        ? file.name.slice(file.name.lastIndexOf("."))
        : "";
    try {
        return new File([file], `${safeLabel}${extension}`, {
            type: file.type,
        });
    }
    catch (error) {
        return file;
    }
};
